// assets/slider-init.js
(function () {
  var SPLIDE_JS_URL = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

  function loadSplideOnce() {
    if (window.Splide) return Promise.resolve(window.Splide);
    if (window._splideLoading) return window._splideLoading;

    window._splideLoading = new Promise(function (resolve, reject) {
      // inject script
      var s = document.createElement('script');
      s.src = SPLIDE_JS_URL;
      s.onload = function () {
        resolve(window.Splide);
      };
      s.onerror = function (err) {
        console.error('[slider-init] splide script failed to load', err);
        reject(err);
      };
      document.body.appendChild(s);
    });

    return window._splideLoading;
  }

  function parseBool(v) {
    return v === true || v === 'true' || v === '1' || v === 1;
  }

  function getOptionsFromEl(el) {
    var columns = parseInt(el.dataset.columns, 10) || 3;
    var arrowsVisible = el.dataset.arrows !== 'hide';
    var autoplay = parseBool(el.dataset.autoplay);
    var interval = parseInt(el.dataset.interval, 10) || 4000;

    return {
      type: 'loop',
      perPage: columns,
      perMove: 1,
      gap: '20px',
      arrows: arrowsVisible,
      pagination: false,
      autoplay: autoplay,
      interval: interval,
      pauseOnHover: true,
      breakpoints: {
        1500: { perPage: Math.max(1, columns) },
        1200: { perPage: Math.max(1, columns - 1) },
        992:  { perPage: Math.max(1, columns - 2) },
        750:  { perPage: 1 }
      }
    };
  }

  function initEl(el) {
    if (!el) return Promise.resolve();
    // prevent multiple simultaneous inits
    if (el.__sliderInitPromise) return el.__sliderInitPromise;

    el.__sliderInitPromise = loadSplideOnce()
      .then(function () {
        // destroy previous
        if (el.__splideInstance) {
          try { el.__splideInstance.destroy(true); } catch (e) { /* ignore */ }
          delete el.__splideInstance;
        }

        var opts = getOptionsFromEl(el);
        var inst = new window.Splide(el, opts);
        inst.mount();
        el.__splideInstance = inst;
        console.log('[slider-init] mounted', el.id);
        return inst;
      })
      .catch(function (err) {
        console.error('[slider-init] failed to init', el.id, err);
      })
      .finally(function () {
        delete el.__sliderInitPromise;
      });

    return el.__sliderInitPromise;
  }

  function destroyEl(el) {
    if (!el) return;
    if (el.__splideInstance) {
      try { el.__splideInstance.destroy(true); } catch (e) { /* ignore */ }
      delete el.__splideInstance;
      console.log('[slider-init] destroyed', el.id);
    }
  }

  function initAll() {
    document.querySelectorAll('.splide').forEach(function (el) {
      initEl(el);
    });
  }

  // initial run (storefront)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify editor events
  document.addEventListener('shopify:section:load', function (e) {
    // init any splide inside loaded section
    var found = e.target.querySelectorAll ? e.target.querySelectorAll('.splide') : [];
    if (found.length) {
      found.forEach(function (el) { initEl(el); });
    } else {
      // fallback: init all
      initAll();
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var found = e.target.querySelectorAll ? e.target.querySelectorAll('.splide') : [];
    found.forEach(function (el) { destroyEl(el); });
  });

  document.addEventListener('shopify:section:select', function (e) { initAll(); });
  document.addEventListener('shopify:block:select', function (e) { initAll(); });
  document.addEventListener('shopify:block:deselect', function (e) { initAll(); });

  // MutationObserver fallback (detect when editor injects HTML)
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.splide')) {
          initEl(node);
        } else {
          var child = node.querySelector && node.querySelector('.splide');
          if (child) initEl(child);
        }
      });
      m.removedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.splide')) {
          destroyEl(node);
        } else {
          var child = node.querySelector && node.querySelector('.splide');
          if (child) destroyEl(child);
        }
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });

})();
